import React from "react";
import Header from "../components/Header";   // <-- Fix: matching About page behavior
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Extra header to match About Us visual stack */}
      <Header />

      <div className="privacy-page">

        {/* HERO SECTION */}
        <div className="privacy-hero-banner">
          <h1 className="privacy-title">Privacy Policy</h1>
        </div>

        {/* MAIN CONTENT */}
        <div className="privacy-content">
          <p>Last Updated: {new Date().toLocaleDateString()}</p>

          <section>
            <h2>1. Introduction</h2>
            <p>
              Welcome to <strong>Oculus Eye Hospital</strong>. Your privacy is important to us.
              This Privacy Policy explains how we collect, use, and safeguard your
              information when you visit our website:{" "}
              <strong>https://oculuseyehospitalassam.com</strong>.
            </p>
          </section>

          <section>
            <h2>2. Information We Collect</h2>
            <p>We may collect the following details:</p>
            <ul>
              <li><strong>Name</strong></li>
              <li><strong>Email address</strong></li>
              <li><strong>Phone number</strong></li>
              <li><strong>Message details (from contact forms)</strong></li>
            </ul>
            <p>We do <strong>not</strong> collect login credentials or store user accounts.</p>
          </section>

          <section>
            <h2>3. How We Use Your Information</h2>
            <p>Your information may be used to:</p>
            <ul>
              <li>Respond to enquiries submitted through our contact forms.</li>
              <li>Improve our communication and services.</li>
              <li>Maintain internal records.</li>
            </ul>
          </section>

          <section>
            <h2>4. Cookies & Hosting</h2>
            <p>
              This website may use basic cookies for functionality. Our website is hosted on{" "}
              <strong>Hostinger</strong>. We do not sell or trade any user information.
            </p>
          </section>

          <section>
            <h2>5. Data Sharing</h2>
            <p>
              We do <strong>not</strong> sell, rent, or share personal data except when
              required for essential service providers (such as hosting).
            </p>
          </section>

          <section>
            <h2>6. No User Accounts</h2>
            <p>
              Our website does not offer user registration or login features; therefore, we do
              not store account-related data.
            </p>
          </section>

          <section>
            <h2>7. Protection & Security</h2>
            <p>
              We take reasonable steps to protect your information. However, no method of
              transmission over the internet is completely secure.
            </p>
          </section>

          <section>
            <h2>8. External Links</h2>
            <p>
              Our website may contain links to third-party websites. We are not responsible
              for the content or privacy practices of these websites.
            </p>
          </section>

          <section>
            <h2>9. Your Rights</h2>
            <p>
              You may request deletion or correction of your stored data by contacting us at
              any time.
            </p>
          </section>

          <section>
            <h2>10. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, contact us:</p>
            <p><strong>Oculus Eye Hospital</strong></p>
            <p><strong>Email:</strong> info@oculuseyehospitalassam.com</p>
          </section>

          <footer className="privacy-footer">
            <p>© {new Date().getFullYear()} Oculus Eye Hospital. All Rights Reserved.</p>
          </footer>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
